module.exports = __webpack_public_path__ + "img/Case_Study_2_Background.f37b49cb.jpg";